enum ActionTypes {
  REQUEST = 'REQUEST',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  CANCEL = 'CANCEL'
}

export default ActionTypes;
